module.exports = __webpack_public_path__ + "static/assets/be25fca420a7f95f05e8b87530324c9a.png";